<template>
  <el-dialog v-model="visible" title="" width="430" :show-close="true" @close="onClose" :close-on-click-modal="false" :close-on-press-escape="false" style="padding: 32px;">
    <div class="modal-content">
      <el-tabs v-model="currentForm" class="demo-tabs"  stretch  style="width: 100%;">
        <el-tab-pane label="用户注册" name="sms" style="margin-top: 30px;">
          <el-form  :model="registerParams"  ref="ruleFormRef" label-position="top" :rules="rules">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="phone" placeholder="请输入手机号"  size="large" autocomplete="username"/>
            </el-form-item>
            <el-form-item label="图形验证码">
              <el-input  v-model="sendSmsParams.captcha" placeholder="请输入验证码"  size="large" style="width:200px"> </el-input>
              <img :src="captchaImgUrl" style="width: 100px; margin-left: 18px; display: inline-block" @click="getSmsCaptchaFn">
            </el-form-item>
            <el-form-item label="短信验证码" prop="code">
              <el-input v-model="registerParams.code" placeholder="请输入验证码"  size="large" autocomplete="off">
                <template #append>
                  <el-button type="primary" @click="sendSmsHandle" plain v-if="!startCountDowned">发送验证码</el-button>
                  <div class="count-down-text-btn" v-show="startCountDowned">
                    <el-countdown :value="twoMinutesInMs"  @finish="onFinish" format="mm:ss" />
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="密 码" prop="password">
              <el-input v-model="registerParams.password"  type="password"  size="large" autocomplete="current-password" placeholder="密码8-20位，至少包括大小写字母、数字、特殊符号" />
            </el-form-item>
            <el-button type="primary" @click="registerHandle(ruleFormRef)" style="width: 100%;">立即注册</el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>



<script setup lang="ts">
import UserService from '../apis/UserService';
import type {  FormInstance, FormRules } from 'element-plus'

interface RuleForm {
  password: string,
  phone: string,
  code: string,
  captcha: string,
}
const ruleFormRef = ref<FormInstance>()

const startCountDowned = ref(false);
const twoMinutesInMs = ref(Date.now() + 2 * 60 * 1000);

// Props 和 Emits 定义
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(['update:show', 'register:success']);

// 变量定义
const visible = ref(props.show);
const currentForm = ref('sms');
const phone = ref('');
const smsCountdown = ref(60);
const isSendingSms = ref(false);
const captchaImgUrl = ref('');

const rules = reactive<FormRules<RuleForm>>({
  phone: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { pattern: /^1\d{10}$/, message: '请输入11位手机号码', trigger: 'blur' }
  ],
  code: [
    { required: true, message: '请输入短信验证码', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '密码8-20位，至少包括大小写字母、数字、特殊符号( @$!%*?&. )', trigger: 'blur' },
    { pattern:  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,20}$/,  message: '密码8-20位，至少包括大小写字母、数字、特殊符号( @$!%*?&. )', trigger: 'blur' }
  ], 
})
const sendSmsParams = ref({
  phone,
  captcha: "",
  captchaKey: "",
});



const registerParams = ref({
  phone,
  code: "",
  password: ""
});

// 计算属性，用于动态显示短信按钮文本
const smsButtonText = computed(() => {
  return isSendingSms.value ? `${smsCountdown.value}秒后重发` : '发送验证码';
});

onMounted(() => {
  getSmsCaptchaFn();
});

// 监听 props.show 的变化来更新 visible
watch(() => props.show, (newVal) => {
  visible.value = newVal;
  if(newVal) {
    getSmsCaptchaFn();
  }
});



// 当 el-dialog 关闭时触发的事件处理函数
const onClose = () => {
  visible.value = false;
  emit('update:show', false);
};



// 获取图形验证码
const getSmsCaptchaFn = () => {
  setTimeout(() => {
    UserService.getSmsCaptcha().then(res => {
      if (res.code == 1) {
        console.log("===================获取图片验证码");
        captchaImgUrl.value = res.data.captchaUrl;
        sendSmsParams.value.captchaKey = res.data.captchaKey;
      } else {
        console.log("服务异常");
      }
    });
  }, 600);
};

const onFinish = () => {
  // 倒计时结束
  startCountDowned.value = false;
};

const sendSmsHandle = () => {
  if (!phone.value || !sendSmsParams.value.captcha) {
    ElMessage.error("请填写完整有效的参数");
    return;
  }
  UserService.sendSmsV1(sendSmsParams.value).then(res => {
    if (res.code == 1) {
      ElMessage.success("发送成功");
      startCountDowned.value = true;
      twoMinutesInMs.value =  Date.now() + 2 * 60 * 1000
      return;
    } else {
      ElMessage.error("发送失败");
      startCountDowned.value = true;
      twoMinutesInMs.value =  Date.now() + 2 * 60 * 1000

    }
  });
};



// 注册提交
const registerHandle = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate((valid) => {
    console.log("valid",valid);
    if (valid) {
      console.log("registerParams",registerParams.value);
      UserService.register(registerParams.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success("注册成功");
          emit('register:success', true);
          visible.value = false;
        } else {
          ElMessage.success(res.msg);
        }
      });
    } else {
      ElMessage.error("请输入有效完整的注册参数");
      return;
    }
  })
};
</script>

<style scoped>
.modal-content {
  padding: 2px;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  position: relative;
}

.header {
  text-align: right;
}

.close-btn {
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-btn:hover {
  color: #333;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.styled-input {
  margin-bottom: 15px;
}

/* 删除默认边框并增强底部线条 */
:deep(.van-cell:not(:last-child)::after) {
  border-bottom: 2px solid #ebedf0;
  left: 0;
  right: 0;
}

.captcha-image {
  height: 36px;
  cursor: pointer;
  border-radius: 4px;
}

.button-container {
  margin-top: 20px;
  padding: 0 32px;
}

.block-button {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 8px;
}

.login-options {
  text-align: left;
  margin-top: 20px;
}

.login-options span {
  color: #047bf1;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;
  display: inline-block;
  font-size: 18px;
}

.login-options span:hover {
  color: #0e67c7;
}
</style>

<style>
.modal-content .el-count-down {
  display: inline-block;
  color: #df0019;
  font-weight: bold;
  background: #c8c9cc;
  text-align: center;
  border-radius: 6px;
  font-size: 16px;
  padding: 6px 16px;
}
</style>